// extracted by mini-css-extract-plugin
module.exports = {"lightBoxRoot":"LightBox_lightBoxRoot__W_Yjj"};